


















import Vue from 'vue'
export default Vue.extend({
  name: 'IconHelp',
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
})
